import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'antd';

// SVGs
import { ReactComponent as IconChevronRight } from '../Sprites/icon-chevron-right.svg';

import { cleanString } from '../../util/renderHelper';
import { detectDocumentLink } from '../ProviderDrawer/linkFunctions';
import smoothscroll from "smoothscroll-polyfill";

import config from '../../config';

smoothscroll.polyfill();

const getUrl = (urls, providerName) =>
  urls.find(url => url.indexOf(`/${providerName}/`) !== -1);

const getPath = providerName => new RegExp(`/${providerName}/(.*)`);

export const navigateUser = (event, paths, isMobile) => {
  const anchorPaths = paths.split("/");
  const providerTabs = document.querySelector(`.provider-tabs`);
  const tabName = anchorPaths[anchorPaths.length - 1];
  const tabType = isMobile ? '.ant-collapse-header' : '.ant-tabs-tab';
  let scrollPos =
    providerTabs.getBoundingClientRect().top +
    document.documentElement.scrollTop;

  event.preventDefault();
    document.querySelectorAll(`.provider-tabs ${tabType}`)[0].click();
    if (document.querySelector(`.${tabName}`)) {
      scrollPos =
        document
          .querySelector(`.${tabName} .ant-collapse-header`)
          .getBoundingClientRect().top + document.documentElement.scrollTop;

      document.querySelector(`.${tabName} .ant-collapse-header`).click();
      setTimeout(function() {
        window.scroll({
          top: scrollPos,
          left: 0,
          behavior: "smooth"
        });
      }, 200);
      return false;
    }
    setTimeout(function() {
      window.scroll({
        top: scrollPos,
        left: 0,
        behavior: "smooth"
      });
    }, 200);
};

const DocumentLinkItem = ({ item: { name, url, urls }, providerName, isMobile }) => {
  const providerUrl = getUrl(urls, providerName);
  if (providerUrl) {
    const path = url
      ? `${config.APP_PATH}${
          providerUrl.match(getPath(providerName))
            ? providerUrl.match(getPath(providerName))[0]
            : ""
        }`
      : null;

    return name && url ? (
      <li className="page-header-quick-links__item">
        <a href={path} className="page-header-quick-links__link" onClick={e => navigateUser(e, url, isMobile)}>
          {cleanString(name)}
          <IconChevronRight className="page-header-quick-links__icon" />
        </a>
      </li>
    ) : (
      ""
    );
  }
  return null;
};

const QuickLinkItem = ({
  item: { name, url, urls },
  providerName,
  openCurrentProcessInfo
}) => {
  const providerUrl = getUrl(urls, providerName);
  if (providerUrl) {
    const path = url
      ? `${config.APP_PATH}${
          providerUrl.match(getPath(providerName))
            ? providerUrl.match(getPath(providerName))[0]
            : ""
        }`
      : null;

    return name && url ? (
      <li className="page-header-quick-links__item">
        <Link
          to={path}
          className="page-header-quick-links__link"
          onClick={openCurrentProcessInfo}
        >
          {cleanString(name)}
          <IconChevronRight className="page-header-quick-links__icon" />
        </Link>
      </li>
    ) : (
      ""
    );
  }
  return null;
};

const QuickLinks = ({
  quickLinks,
  isMobile,
  providerName,
  openCurrentProcessInfo
}) => {
  const displayQuickLinks = quickLinks.map((item, key) => {
    const anchorPaths = item.url;
    return (
    isMobile && key < 2 ? (
      !detectDocumentLink(anchorPaths) ? (
      <QuickLinkItem
        item={item}
        key={`quick-link-${key}`}
        providerName={providerName}
        openCurrentProcessInfo={openCurrentProcessInfo}
      />
      ) : (
        <DocumentLinkItem 
            item={item} 
            key={`quick-link-${key}`} 
            providerName={providerName}
            isMobile={isMobile}
          />
      )
    ) : (
      !isMobile && (
        !detectDocumentLink(anchorPaths) ? (
          <QuickLinkItem
          item={item}
          key={`quick-link-${key}`}
          providerName={providerName}
          openCurrentProcessInfo={openCurrentProcessInfo}
        />
        ) : (
          <DocumentLinkItem 
            item={item} 
            key={`quick-link-${key}`} 
            providerName={providerName}
            isMobile={isMobile}
          />
        )
      )
    )
    )}
  );
  return !!quickLinks.length ? (
    <Row className="fixed">
      <Col xs={{ span: 22, offset: 1 }} lg={{ span: 12, offset: 0 }}>
        <nav className="page-header-quick-links">
          <h2 className="page-header-quick-links__heading">
            Are you looking for&hellip;
          </h2>
          <ul className="page-header-quick-links__list">{displayQuickLinks}</ul>
        </nav>
      </Col>
    </Row>
  ) : (
    ''
  );
};

export default QuickLinks;
